module.exports = __webpack_public_path__ + "img/discts.9b722eb.jpg";